import { render, staticRenderFns } from "./RaceCard.vue?vue&type=template&id=095d628b&scoped=true&"
import script from "./RaceCard.vue?vue&type=script&lang=js&"
export * from "./RaceCard.vue?vue&type=script&lang=js&"
import style0 from "./RaceCard.vue?vue&type=style&index=0&id=095d628b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095d628b",
  null
  
)

export default component.exports